import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "visitor-profile" }
const _hoisted_2 = { style: {"display":"flex","width":"100%","align-items":"center"} }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "blacklist__image" }
const _hoisted_5 = {
  class: "preview",
  style: {"padding-left":"15px"}
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "dialog-footer" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Exit")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_time_picker = _resolveComponent("el-time-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 15 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "visitorType",
              label: _ctx.trans('label.visitor-type'),
              rules: {
						required: true,
						message: _ctx.trans('message.field_require', _ctx.trans('label.visitor-type'))
					}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.model.visitorType,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.visitorType) = $event)),
                  placeholder: _ctx.trans('label.nothing-selected'),
                  "automatic-dropdown": false
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.types, (type) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: type,
                        label: _ctx.trans('visitorType.' + type.recordTypeName),
                        value: type.recordTypeId
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label", "rules"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 9,
          style: {"padding-left":"20px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "entryType",
              label: _ctx.trans('label.entry-type')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.model.entryType,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.entryType) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: "Single-entry" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.trans("label.single-entry")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "1-Day" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.trans("label.1day")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showBlacklistInfo,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.showBlacklistInfo) = $event)),
      title: _ctx.trans('label.blacklist'),
      width: "100%",
      "before-close": _ctx.handleClose
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_7, [
          _createVNode(_component_el_button, {
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showBlacklistInfo = false))
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: _ctx.blacklists,
          style: {"widtih":"100%"},
          "max-height": "300px",
          "highlight-current-row": "",
          onCurrentChange: _ctx.handleCurrentChange,
          ref: "blackListTableRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString((_ctx.currentRow = _ctx.blacklists[0])), 1),
            _createVNode(_component_el_table_column, {
              fixed: "",
              label: _ctx.trans('label.name'),
              width: "320px"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("img", {
                    style: {"width":"120px","margin-right":"10px"},
                    src: scope.row.image
                  }, null, 8, _hoisted_3),
                  _createElementVNode("span", null, _toDisplayString(scope.row.salutation +
								(scope.row.lastName ? " " + scope.row.lastName : "")+
								(scope.row.firstName ? " " + scope.row.firstName : "")), 1)
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "phone",
              label: _ctx.trans('label.phone'),
              width: "100px"
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "blacklistedBy",
              label: _ctx.trans('label.blacklisted-by'),
              width: "200px"
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "remarks",
              label: _ctx.trans('label.remarks')
            }, null, 8, ["label"])
          ]),
          _: 1
        }, 8, ["data", "onCurrentChange"]),
        (_ctx.currentRow)
          ? (_openBlock(), _createBlock(_component_el_row, {
              key: 0,
              style: {"margin-top":"20px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 14 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              prop: "salutation",
                              label: _ctx.trans('label.salutation')
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.currentRow.salutation,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentRow.salutation) = $event)),
                                  disabled: "",
                                  readonly: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_option, {
                                      label: _ctx.trans('label.mr'),
                                      value: "Mr"
                                    }, null, 8, ["label"]),
                                    _createVNode(_component_el_option, {
                                      label: _ctx.trans('label.ms'),
                                      value: "Ms"
                                    }, null, 8, ["label"]),
                                    _createVNode(_component_el_option, {
                                      label: _ctx.trans('label.mrs'),
                                      value: "Mrs"
                                    }, null, 8, ["label"]),
                                    _createVNode(_component_el_option, {
                                      label: _ctx.trans('label.miss'),
                                      value: "Miss"
                                    }, null, 8, ["label"]),
                                    _createVNode(_component_el_option, {
                                      label: _ctx.trans('label.prof'),
                                      value: "Prof"
                                    }, null, 8, ["label"]),
                                    _createVNode(_component_el_option, {
                                      label: _ctx.trans('label.dr'),
                                      value: "Dr"
                                    }, null, 8, ["label"])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              prop: "lastName",
                              label: _ctx.trans('label.last-name')
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.currentRow.lastName,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currentRow.lastName) = $event)),
                                  readonly: "",
                                  disabled: ""
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              prop: "firstName",
                              label: _ctx.trans('label.first-name')
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.currentRow.firstName,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.currentRow.firstName) = $event)),
                                  readonly: "",
                                  disabled: ""
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { span: 12 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              prop: "phone",
                              label: _ctx.trans('label.phone')
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.currentRow.phone,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.currentRow.phone) = $event)),
                                  readonly: "",
                                  disabled: ""
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 12 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              prop: "email",
                              label: _ctx.trans('label.email')
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.currentRow.email,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.currentRow.email) = $event)),
                                  readonly: "",
                                  disabled: ""
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { span: 4 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              prop: "isHenderson",
                              label: "Henderson"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_switch, {
                                  modelValue: _ctx.currentRow.isHenderson,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.currentRow.isHenderson) = $event)),
                                  readonly: "",
                                  disabled: ""
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 20 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              prop: "blacklistedBy",
                              label: _ctx.trans('label.blacklisted-by')
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.currentRow.blacklistedBy,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.currentRow.blacklistedBy) = $event)),
                                  readonly: "",
                                  disabled: ""
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              prop: "remarks",
                              label: _ctx.trans('label.remarks')
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.currentRow.remarks,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.currentRow.remarks) = $event)),
                                  type: "textarea",
                                  readonly: "",
                                  disabled: "",
                                  rows: "6"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 10 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("img", {
                          class: "preview-img",
                          style: {"width":"100%","height":"auto"},
                          src: _ctx.currentRow.image || _ctx.visitorImage
                        }, null, 8, _hoisted_6)
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "title", "before-close"]),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 6 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "salutation",
              label: _ctx.trans('label.salutation'),
              rules: {
						required: true,
						message: _ctx.trans('message.field_require', _ctx.trans('label.salutation'))
					}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.model.salutation,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.model.salutation) = $event)),
                  "automatic-dropdown": false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: _ctx.trans('label.mr'),
                      value: "Mr"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _ctx.trans('label.ms'),
                      value: "Ms"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _ctx.trans('label.mrs'),
                      value: "Mrs"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _ctx.trans('label.miss'),
                      value: "Miss"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _ctx.trans('label.prof'),
                      value: "Prof"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _ctx.trans('label.dr'),
                      value: "Dr"
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label", "rules"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 9 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "lastName",
              label: _ctx.trans('label.last-name'),
              rules: {
						required: true,
						message: _ctx.trans('message.field_require', _ctx.trans('label.last-name'))
					}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  ref: "name",
                  modelValue: _ctx.model.lastName,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.model.lastName) = $event)),
                  maxlength: "50",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label", "rules"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 9 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "firstName",
              label: _ctx.trans('label.first-name')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.model.firstName,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.model.firstName) = $event)),
                  maxlength: "50",
                  "show-word-limit": "",
                  onBlur: _ctx.checkBlacklist
                }, null, 8, ["modelValue", "onBlur"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }),
        (_ctx.blacklisted)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "el-form-item__error blacklisted-error",
              onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.showBlacklistInfo = true), ["prevent"]))
            }, " This visitor is blacklisted "))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "contactNo",
              label: _ctx.trans('label.visitor-phone-no'),
              rules: {
						required: true
					}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.model.contactNo,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.model.contactNo) = $event)),
                  maxlength: "20",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "visitorCompany",
              label: _ctx.trans('label.visitor-company')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.model.visitorCompany,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.model.visitorCompany) = $event)),
                  maxlength: "100",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 8 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "visitDate",
              label: _ctx.trans('label.visit-date'),
              rules: {
						required: true,
						message: _ctx.trans('message.field_require', _ctx.trans('label.visit-date'))
					}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.visitDate,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.visitDate) = $event)),
                  type: "date",
                  placeholder: _ctx.trans('label.nothing-selected'),
                  format: "DD-MM-YYYY",
                  clearable: false
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label", "rules"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 8 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "visitTime",
              label: _ctx.trans('label.visit-time')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_time_picker, {
                  modelValue: _ctx.model.visitTime,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.model.visitTime) = $event)),
                  placeholder: _ctx.trans('label.nothing-selected'),
                  format: "HH:mm"
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 8 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "otherName",
              label: _ctx.trans('label.event-name')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.model.otherName,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.model.otherName) = $event)),
                  maxlength: "200",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_form_item, {
      prop: "remarks",
      label: _ctx.trans('label.remarks')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: _ctx.model.remarks,
          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.model.remarks) = $event)),
          type: "textarea",
          maxlength: 200,
          rows: 2,
          "show-word-limit": ""
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["label"])
  ]))
}